import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Card } from "./ui/card";
import { useWalletBalance } from "@/hooks/use-balance";
import { useWallet } from "@/hooks/use-wallet";
import { formatMoneyTotal } from "@/utils/format";
import { useUser } from "@/hooks/use-user";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";

const PaymentConfirmationDialog: React.FC<{
    open: boolean;
    children?: React.ReactNode;
    amount: number;
    onConfirm: () => void;
    onCancel: () => void;
}> = (props) => {
    const userData = useUser()

    return <>
        <Dialog open={props.open}>
            {props.children}

            <DialogContent className="bg-[#2F2F32] rounded-[12px] w-[90%]">
                <DialogHeader className="text-white">
                    <DialogTitle className="text-center flex justify-center">
                        Transaction Confirmation
                    </DialogTitle>
                </DialogHeader>

                <div className="flex justify-center items-center gap-3 flex-col text-[#F3F3F3]">
                    <p>
                        The following amount will be withdrawn from your balance:
                    </p>
                    <h3 className="text-2xl font-bold text-primary">
                        {formatMoneyTotal(props.amount)} SECH
                    </h3>
                    <p>
                        Your current balance is <span className="font-bold">
                            {formatMoneyTotal(userData.balance)} SECH
                        </span>
                    </p>

                    <Separator className="mt-8" />

                    <div className="flex flex-col gap-4 w-full mt-4">
                        <Button onClick={props.onConfirm}>
                            Confirm payment
                        </Button>
                        <Button variant="outline" onClick={props.onCancel} className="text-primary">
                            Cancel
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    </>
}

export default PaymentConfirmationDialog;